import { ROUTE as APP_ROUTE } from '~/app/routes';

export interface PendingPlatformInvite {
  inviteCode: string;
  platformId: string;
}

export const getPendingPlatformInvite = (redirectUrl?: string): PendingPlatformInvite | undefined => {
  if (!redirectUrl?.startsWith('/')) {
    return undefined;
  }

  let url: URL;
  try {
    url = new URL(redirectUrl, 'https://dashboard.column.com');
  } catch {
    return undefined;
  }

  if (url.pathname !== APP_ROUTE.ROOT && !url.pathname.startsWith(`${APP_ROUTE.ROOT}/`)) {
    return undefined;
  }

  const inviteCode = url.searchParams.get('code');
  const platformId = url.searchParams.get('invite');
  if (!inviteCode || !platformId) {
    return undefined;
  }

  return { inviteCode, platformId };
};

export const getPlatformInviteRedirect = (invite?: PendingPlatformInvite): string | undefined => {
  if (!invite) {
    return undefined;
  }

  const search = new URLSearchParams({ invite: invite.platformId });
  return `${APP_ROUTE.ROOT}?${search.toString()}`;
};
